import axios from 'axios';
import {useFormik } from 'formik';
import React, { useContext } from 'react';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { AuthContxt } from '../AuthContext';
import loginImg from '../../Assets/images/031fef95c15b615572f6944264db205d.jpg'


export default function Login() {
   const [errorMsg, seterrorMsg] = useState()
   const [isloading , setisloading] = useState()
   const {UserLoggedIn , setUserLoggedIn} = useContext(AuthContxt)

   const navigate = useNavigate()
     const validationSchema = yup.object({
      email : yup.string().required("Email Field is required").matches(/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/i , "Enter Valid Email"),
      password : yup.string().required("password Field is required"),
    
     })
  


  const {values , handleSubmit , handleChange ,errors , touched , handleBlur , isValid}= useFormik({
      initialValues:{
        email :'',
        password:'',
      
      },
      onSubmit : async ()=>{
       try {
        setisloading(true)
        let response = await axios.post('https://ecommerce.routemisr.com/api/v1/auth/signin',values)
        console.log(response.data.message)
        if(response.data.message=="success"){
          setUserLoggedIn(true)
          localStorage.setItem('token' ,response.data.token)
          
          if (window.location.pathname !='/login') {
            navigate(window.location.pathname)

          }else {
            navigate('/home')

          }
        }
       } catch (error) {
        seterrorMsg(error.response.data.message)

       }
       setisloading(false)
      },

      validationSchema
     })

  return <>
  <div className="container">
  <div className='inner-login'>
    <div className="m-auto  loginDiv p-3 p-xl-5 ">
      <h1>Login Now :</h1>
      <div className="row">
        <div className="col-md-6">
        <form onSubmit={handleSubmit}>
        
        <label htmlFor="email" className='my-1'>Email:</label>
         <input onChange={handleChange} value={values.email} type="email" className='form-control mb-3 authoinputs' id='email' name='email' />
         {errors.email && touched.email &&  <p className='alert alert-danger'>{errors.email}</p>}       
 
         <label htmlFor="password" className='my-1'>Password:</label>
         <input onChange={handleChange} onBlur={handleBlur} value={values.password} type="password" className='form-control mb-3 authoinputs' id='password' name='password' />
         {errors.password && touched.password &&  <p className='alert alert-danger'>{errors.password}</p>}       
 
      
        {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}
        {         isloading ? <button disabled type='button' className='btn bg-main px-3 text-white ms-auto d-block px-3'> <i className='fas fa-spin fa-spinner px-4'></i> </button>
                   :
                   <button type='submit' disabled ={isloading} className='btn bg-main px-3 text-white ms-auto d-block'>Login</button>
       }
         <Link to={'/ForgetPassword'} className='forgetLink'> Forget Password ?</Link>
 
       </form>
        </div>
        <div className="col-md-6">
          <img src={loginImg} className='w-100'/>
        </div>
      </div>
    </div>
    </div>
  </div>
  </>
}
